import { CountryCode } from '@domains/country';
import { calculateYears } from './calculateYears';

export const hermesDataByCountry: Record<CountryCode, (formData: any) => any> =
  {
    [CountryCode.MX]: formData => ({
      area: Number(formData.committeePriceArea),
      room_num: Number(formData.rooms),
      garage: Number(formData.garage),
      elevator: Number(formData.elevator),
      bath: Number(formData.baths),
      half_bathroom: Number(formData.halfBaths),
      years_old: Number(formData.yearsOld),
      floor_num: Number(formData.floor),
      land_area: Number(formData.committeeLandArea),
      property_type_id: Number(formData.propertyType),
      zip_code: formData.zipCode,
    }),
    [CountryCode.CO]: formData => ({
      area: Number(formData.area),
      garage: Number(formData.garage),
      bath: Number(formData.baths),
      floor_num: Number(formData.floor),
      admin_price: Number(formData.adminPrice),
      years_old: calculateYears(formData.constructionDate),
    }),
  };

export const transformHermesData = (country: CountryCode, formData: any) => {
  const transformFunction = hermesDataByCountry[country] || (data => data);
  return transformFunction(formData);
};
